import { Navigate, Outlet } from "react-router-dom";

import { ROUTES } from "@/constants/routes";
import { cn } from "@/lib/cn";

import { useUserStore } from "@/store/userStore";

export const AuthLayout = () => {
  const isAuthenticated = useUserStore((s) => s.isAuthenticated);

  if (isAuthenticated) {
    return (
      <Navigate
        to={ROUTES.dashboard}
        replace
      />
    );
  }

  return (
    <div className="bg-bg min-h-dvh p-5">
      <div className="flex h-[calc(100dvh-2.5rem)] gap-4">
        {/* Form side */}
        <div className="bg-bg rounded-mds flex flex-1 items-center justify-center sm:border-2 sm:border-neutral-900">
          <div className="w-full max-w-104 sm:px-6">
            <Outlet />
          </div>
        </div>

        {/* Image side */}
        <div
          className={cn(
            "bg-bg rounded-mds relative hidden flex-1 flex-col items-center overflow-hidden",
            "xl:flex"
          )}
        >
          {/* Background glow */}
          <img
            src="/images/landing/main-bg.png"
            alt=""
            className="pointer-events-none absolute inset-0 h-full w-full object-cover"
          />

          {/* Title */}
          <p
            className={cn(
              "font-pixel text-neutral-50 z-10 mb-8 pt-18 text-center text-[1.5rem] uppercase"
            )}
          >
            trading bot
          </p>

          {/* Phone mockup */}
          <div className="pointer-events-none z-10 relative flex flex-1 min-h-0 w-full justify-center">
              <img
                src="/images/landing/phone-app.png"
                alt="Trading Bot App"
                className={cn(
                  "select-none absolute left-1/2 bottom-0 -translate-x-1/2",
                  "translate-y-[18%]",
                  "w-auto h-auto max-w-[90%] max-h-[115%]",
                  "object-contain"
                )}
              />
          </div>
        </div>
      </div>
    </div>
  );
};
